<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="d-flex justify-content-between my-4">
                <div class="h5" v-text="$t('wallets.label.settlement')"></div>
                <div>
                    <router-link class="btn btn-success my-2 btn-width-100" to="/wallets">
                        {{ $t('label.back') }}
                    </router-link>
                </div>
            </div>
            <active-token v-show="false"
                    :title="$t('label.bank_status')"
            />
            <div class="row justify-content-center my-4">
                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" id="password" name="password" type="password" v-model="password.value">
                </div>

                <div :key="index" v-for="(item, index) in form_data">
                    <div class="row border border-success m-2 px-2 py-4">
                        <div>
                            <p class="mx-4"> {{index+1}}. {{'مبلغ قابل برداشت (بدون در نظر گرفتن کارمزد): ' +
                                calculated_amount + ' ریال' }}</p>
                        </div>
                        <div class="col-12">
                            <div @click="deleteRow(index)"
                                 class="text-danger mr-auto"
                                 style="cursor: pointer; width: fit-content;"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                            <label :for="`transfers.${index}.amount`" v-text="$t('label.amount_rial')"></label>
                            <amount-input
                                    :item="form_data[index]"
                                    :item_id="`transfers.${index}.amount`"
                                    :item_name="`transfers.${index}.amount`"
                            ></amount-input>

                        </div>
                        <div class="col-12 col-md-4 mb-2">
                            <label :for="`transfers.${index}.destination_number`"
                                   v-text="$t('label.destination_number')"></label>
                            <input :id="`transfers.${index}.destination_number`"
                                   :name="`transfers.${index}.destination_number`"
                                   :style="isValidIban(form_data[index].destination_number) ? '' : 'border-color: red !important;'"
                                   @change="checkIban(form_data[index].destination_number, index)"
                                   @keyup="checkIban(form_data[index].destination_number, index)"
                                   class="form-control en_num transfers_destination_number"
                                   dir="ltr"
                                   type="text"
                                   v-model="form_data[index].destination_number"
                            >
                            <small class="text-success">{{getBankNickname(form_data[index].destination_number)
                                }}</small>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                            <label :for="`transfers.${index}.track_id`">
                                {{ $t('label.user_track_id') + " (" + $t('label.optional') + ")" }}
                            </label>
                            <input :id="`transfers.${index}.track_id`" :name="`transfers.${index}.track_id`"
                                   class="form-control en_num" dir="ltr"
                                   type="text"
                                   v-model="form_data[index].track_id">
                        </div>
                        <div class="col-12 col-md-4 my-2">
                            <label :for="`transfers.${index}.destination_name`"
                                   v-text="$t('label.destination_firstname')"></label>
                            <input :id="`transfers.${index}.destination_name`"
                                   :name="`transfers.${index}.destination_name`"
                                   class="form-control"
                                   type="text"
                                   v-model="form_data[index].destination_name"
                                   :disabled="lockedFields[index]"
                                   >
                        </div>

                        <div class="col-12 col-md-4 my-2">
                            <label :for="`transfers.${index}.payment_id`"
                                   v-text="`${$t('wallets.label.payment_id')}  (${$t('label.optional')})`"></label>
                            <input :id="`transfers.${index}.payment_id`"
                                   :name="`transfers.${index}.payment_id`"
                                   class="form-control"
                                   type="text"
                                   v-model="form_data[index].payment_id"
                            >
                            <small class="text-success">این فیلد مخصوص حساب های شناسه دار می باشد.</small>
                        </div>
                        <div
                             v-if="canHaveInstitutionId(form_data[index].destination_number)"
                             class="col-12 col-md-4 my-2"
                             :id="`${index}.institution_id.div`"
                        >
                            <label :for="`transfers.${index}.institution_id`"
                                   v-text="`${$t('wallets.label.institution_id')}  (${$t('label.optional')})`">
                            </label>
                            <input :id="`transfers.${index}.institution_id`"
                                   :name="`transfers.${index}.institution_id`"
                                   class="form-control"
                                   type="text"
                                   v-model="form_data[index].institution_id"
                            >
                            <small class="text-success">این فیلد مخصوص حساب های شناسه دار سامان می باشد. (به اشتباه شناسه واریز را در این فیلد ارسال نکنید)</small>
                        </div>
                        <div class="col-12 col-md-4 my-2">
                            <label :for="`transfers.${index}.transfer_type`"
                                   v-text="`${$t('wallets.label.transfer_type')}`"></label>
                            <select :id="`transfers.${index}.transfer_type`"
                                    :name="`transfers.${index}.transfer_type`"
                                    class="form-control"
                                    v-model="form_data[index].transfer_type"
                            >
                                <option :value="walletSettlementTransferType.Direct"
                                        selected
                                        v-text="walletSettlementTransferTypeStr.get(walletSettlementTransferType.Direct)"
                                ></option>
                                <option :value="walletSettlementTransferType.Queued"
                                        v-text="walletSettlementTransferTypeStr.get(walletSettlementTransferType.Queued)"
                                ></option>
                            </select>
                            <small class="text-success"
                                   v-if="form_data[index].transfer_type === walletSettlementTransferType.Direct"
                            >در نوع مستقیم، برداشت بعد از چند دقیقه به صورت خودکار به بانک ارسال میگردد و لغو
                                برداشت فقط در این مدت محدود امکان پذیر میباشد.</small>
                            <small class="text-success"
                                   v-if="form_data[index].transfer_type === walletSettlementTransferType.Queued"
                            >در نوع در صف، برداشت یک ساعت قبل از سیکل پایا به بانک ارسال میگردد.</small>
                        </div>
                        <div class="col-12 col-md-12 my-2">
                            <label :for="`transfers.${index}.transfer_description`">
                                {{ $t('label.description') + " (" + $t('label.optional') + ")" }}
                            </label>
                            <textarea
                                    :id="`transfers.${index}.transfer_description`"
                                    :name="`transfers.${index}.transfer_description`"
                                    class="form-control"
                                    cols="30"
                                    rows="4"
                                    v-model="form_data[index].transfer_description"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5 pt-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center justify-content-between">
                            <button @click="addRow()"
                                    class="btn btn-primary mx-2"
                                    type="button"
                                    v-text="$t('label.add_new_record')"
                            >
                            </button>
                            <div class="d-inline-block mx-2">
                                <label class="d-block mb-0 pb-0" for="new_shareholder"
                                       style="color: transparent; user-select: none; height: 0;">
                                    {{
                                    $t('label.add_new_shareholder')
                                    }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <!-- dont remove spaces -->
                                </label>
                                <select class="form-control kt-selectpicker"
                                        id="new_shareholder"
                                        name="new_shareholder"
                                        v-model="new_shareholder"
                                >
                                    <option :key="index"
                                            :value="shareholder"
                                            v-for="(shareholder, index) in shareholders"
                                            v-text="shareholder.first_name + ' ' + shareholder.last_name"
                                    ></option>
                                </select>
                            </div>
                            <div class="d-inline-block mx-2"
                                 v-if="new_shareholder !== null"
                            >
                                <select class="form-control"
                                        id="new_account_number"
                                        name="new_account_number"
                                        v-model="new_account_number"
                                >
                                    <option :value="null" disabled selected
                                            v-text="$t('label.add_new_account_number')"></option>
                                    <option :key="index"
                                            :value="account_number"
                                            v-for="(account_number, index) in new_shareholder.account_numbers"
                                            v-text="account_number"
                                    ></option>
                                </select>
                            </div>
                        </div>
                        <div v-if="should_two_factor_settlement">
                            <button :disabled="form_meta_data.submit_btn_progress"
                                    class="btn btn-success mr-auto"
                                    id="submit_button"
                                    type="submit"
                            >
                                <div class="d-flex align-items-center">
                                    <div v-text="$t('btn.send_code')"></div>
                                    <div class="ml-2 spinner-border spinner-border-sm"
                                         role="status" v-if="form_meta_data.submit_btn_progress"></div>
                                </div>
                            </button>
                        </div>
                        <div v-else>
                            <button :disabled="form_meta_data.submit_btn_progress"
                                    class="btn btn-success mr-auto"
                                    id="submit_button"
                                    type="submit"
                            >
                                <div class="d-flex align-items-center">
                                    <div v-text="$t('wallets.btn.create_settlement_request')"></div>
                                    <div class="ml-2 spinner-border spinner-border-sm"
                                         role="status" v-if="form_meta_data.submit_btn_progress"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <otp-modal
            :loading="form_meta_data.submit_btn_progress"
            :message="$t('label.input_verification_code')"
            :two_factor_type="form_data.two_factor_type"
            @emitAction="setOtp"
            @sendRequest="sendRequest"
        />
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import {ibanInfo, walletShareHolderService} from "@/common/api.service";
    import Inputmask from 'inputmask';
    import AmountInput from "@/components/custom-elements/amount-input";
    import IranSheba from "iran-sheba";
    import Axios from 'axios';
    import $ from 'jquery';
    import {
        walletSettlementTransferType,
        walletSettlementTransferTypeStr
    } from "@/constants/walletSettlementTransferType";
    import ActiveToken from "../../components/active-token.vue";
    import otpModal from "@/components/elements/modal/otp-modal.vue";
    import {TwoFactorType} from "@/constants/TwoFactorType";

    export default {
        components: {otpModal, AmountInput, ActiveToken},
        data() {
            return {
                walletSettlementTransferType,
                walletSettlementTransferTypeStr,
                shareholders: [],
                new_shareholder: null,
                new_account_number: null,
                wallet_amount: null,
                last_iban_check: '',
                should_two_factor_settlement: false,
                lockedFields: {}
            };
        },
        watch: {
            new_account_number(value) {
                if (value === null) {
                    return;
                }

                // if last record is empty, fill it. otherwise add new record
                if (this.form_data[this.form_data.length - 1].destination_number === ''
                    && this.form_data[this.form_data.length - 1].destination_name === ''
                ) {
                    this.form_data[this.form_data.length - 1].transfer_type = walletSettlementTransferType.Direct;
                    this.form_data[this.form_data.length - 1].destination_number = this.new_account_number;
                    this.form_data[this.form_data.length - 1].destination_name =
                        this.new_shareholder.first_name + ' ' + this.new_shareholder.last_name;
                } else {
                    this.form_data.push({
                        amount: '',
                        destination_number: this.new_account_number,
                        destination_name: this.new_shareholder.first_name + ' ' + this.new_shareholder.last_name,
                        transfer_description: '',
                        track_id: '',
                        transfer_type: walletSettlementTransferType.Direct,
                    });
                }

                this.new_account_number = null;
                this.new_shareholder = null;
                $('#new_shareholder').val(null).change();
            },
            transfer_length() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
        computed: {
            transfer_length() {
                return this.form_data.length;
            },
            calculated_amount() {
                let sum = 0;

                for (let i = 0; i < this.transfer_length; ++i) {
                    sum += this.formatLess(this.form_data[i].amount);
                }

                sum = this.formatLess(this.wallet_amount) - sum;

                if (sum < 0) {
                    return 0;
                }

                return this.moneyFormat(sum);
            },
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: Array,
            password: Object,
        },
        mounted() {
            walletShareHolderService.shareholderList().then(res => {
                this.shareholders = res.data.data;

                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('label.add_new_shareholder'),
                    selectAllText: i18n.t('label.add_new_shareholder'),
                    noneSelectedText: i18n.t('label.add_new_shareholder'),
                });
            });

            this.initShebaMask();

            Axios.get('wallet/common?wallet_prefix=A').then(response => {
                response.data.data.forEach(wallet => {
                    if (wallet.id === this.$route.params.hashid) {
                        this.wallet_amount = wallet.available_amount;
                        this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    }
                })
            });
        },
        methods: {
            sendRequest(type) {
                this.form_data.two_factor_type = type;
                if (type === TwoFactorType.SMS) this.on_submit()
            },
            setOtp(data) {
                this.form_data.otp = data;
                this.$emit('settlement')
            },
            getBankNickname(sheba) {
                sheba = sheba.replace(/[\-_ ]/g, '')
                const bank = IranSheba.recognize(sheba);
                if (bank) {
                    return bank.persianName;
                }
                return ""; // default value for when this function failed to recognize the bank name
            },
            formatLess(price) {
                if (price == null || price === '' || price === 0) {
                    return 0;
                }

                return parseInt(price.replace(/,/g, ''));
            },
            isValidIban(iban) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (iban.length !== 26) { // 26 with IR
                    return false;
                }

                return IranSheba.isValid(iban);
            },
            canHaveInstitutionId(sheba){
                return this.getBankNickname(sheba) === 'بانک سامان'
            },
            checkIban(iban, index) {
                iban = iban.replace(/[\-_ ]/g, '');
                if (!this.isValidIban(iban)) {
                    return;
                }
            
                if (this.last_iban_check === iban) {
                    return;
                } else {
                    this.last_iban_check = iban;
                
                    setTimeout(() => {
                        this.last_iban_check = '';
                    }, 1000);
                }
            
                $('#submit_button').focus();
            
                let params = {
                    iban: iban,
                };
            
                let hashid = this.$route.params.hashid;

                ibanInfo.get(params, hashid).then(res => {
                    let data = res.data.data;
                    this.form_data[index].destination_name = data.first_name + ' ' + data.last_name;

                    this.lockedFields[index] = true;

                    this.$forceUpdate();
                });

                if (this.getBankNickname(iban) === 'بانک سامان') {
                    this.$forceUpdate();
                }
            },

            moneyFormat(price) {
                const pieces = parseFloat(price).toFixed(0).split("");
                let ii = pieces.length;
                while ((ii -= 3) > 0) {
                    pieces.splice(ii, 0, ",");
                }
                return pieces.join("");
            },
            deleteRow(index) {
                if (this.form_data.length < 2) {
                    return;
                }

                this.form_data.splice(index, 1);
            },
            addRow() {
                if (this.form_data.length > 100) {
                    return;
                }

                this.form_data.push({
                    amount: '',
                    destination_number: '',
                    destination_name: '',
                    transfer_description: '',
                    track_id: '',
                    transfer_type: walletSettlementTransferType.Direct,
                });
            },
            initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
            },
        }
    }
</script>

<style scoped>
    .filter_green {
        filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
    }

    .back-flex {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }

    a:hover.wage_wallet {
        color: gray;
    }
</style>
